import { inject, Injectable } from "@angular/core";
import { EventManagerService } from "@wms/app";

@Injectable({
    providedIn: 'root'
})

export class PageStructureService {
    private eventManager: EventManagerService;
    private alreadySelectedCategory: string | null = null;

    constructor() {
        this.eventManager = inject(EventManagerService);

        this.eventManager.widgetSelectionObservable().subscribe((data: any) => {
            this.alreadySelectedCategory = $('#wms-workspace-nav li').children('.active').attr('name') || null;
        });
        this.eventManager.pageTabChangeObservable().subscribe((data: any) => {
            this.alreadySelectedCategory = data || null;
        });
    }

    treeNodeHighlight(container: any, type: any, draggingEl: any, addWidgetInfo: any, side?: string, $refEl?: any) {
        container = container.closest('[widget-id]');
        let targetParentName = container.attr('name') || container.data('droptarget-for').replace('wm_', '') || container.parent().attr('name');

        if (targetParentName.startsWith('page_content')) {
            targetParentName = container.parent().attr('name')
        }
        const targetCanvasEl = $refEl?.length ? $refEl.get(0) : null;

        const targetNodeName = (targetCanvasEl?.getAttribute('name') || targetParentName || '').toString();
        // Highlight active node
        $('.tree-node').removeClass('drag-over-parent')
        $('[data-nodename="' + targetParentName + '"]')?.addClass('drag-over-parent');

        // tree node element 
        const targetNodeEl = $(`.wm-tree-container [data-nodename="${targetNodeName}"]`)[0];
        const targetWidgetId = (targetCanvasEl?.getAttribute('widgetid'))?.toString()

        if (!targetNodeEl) {
            this.eventManager.emitExpandTreeNodeEvent(targetWidgetId);
            return;
        }

        let node = document.querySelector(`[data-nodename="${targetNodeName}"]`) as HTMLElement;
        if (node) {
            const treeContainer = document.querySelector('.treecontent-wrap') as HTMLElement;
            if (side === 'right' || side === 'bottom') {
                const targetNode = $(`.wm-tree-container [data-nodename="${targetNodeName}"]`);
                if (targetNode.length) {
                    const parent = targetNode.parent();
                    const lastChild = parent.children().last();

                    if (lastChild.length) {
                        node = lastChild[0] as HTMLElement;
                    }
                }

            }
            this.scrollElementIntoView(node, treeContainer)
        }

        const style = getComputedStyle(targetNodeEl);
        let paddingLeft = parseInt(style.paddingLeft || '0', 10);
        paddingLeft = type === 'nochildren' ? paddingLeft + 20 : paddingLeft
        const width = parseInt(style.width, 10) - paddingLeft;
        // canvas drag element
        let draggingNodeName = addWidgetInfo?.widgetType || draggingEl.getAttribute('name');
        const draggingNodeType = addWidgetInfo?.widgetType || draggingEl.getAttribute('widgettype');

        let icon = draggingNodeType.replace('wm-', '');
        if (draggingNodeType.startsWith('wm-chart')) {
            icon = draggingNodeType.replace('wm-', '').split('-').reverse().join('');
        } else if (draggingNodeName.startsWith('wm-composite')) {
            icon = draggingNodeType.split('wm-composite-')[1];
            draggingNodeName = icon
        } else if (draggingNodeType === 'wm-form-field' || draggingNodeType === 'wm-filter-field') {
            icon = 'text'
        }

        const iconClass = 'tree-node wm-icon widget-icon wms wms-code-block wms-widget-' + icon;

        const $previewNode = $(`<li class="tree-node tree-node-preview-prev tree-node-preview "> <a class="label"><i class="${iconClass}"></i>${draggingNodeName.replace('wm-', '')}</a> </li>`)
            .css({ 'padding-left': paddingLeft, background: '#273F5B', position: 'relative' }).each(function () {
                this.style.setProperty('--prev-width', `${width}px`);
            });

        $('.tree-node-preview').remove();
        $('.preview-dropdown').remove()

        const $targetNode = $(`.wm-tree-container [data-nodename="${targetNodeName}"]`);
        const $parent = $targetNode.parent();
        const dropdownIcon = `<i class="toggle preview-dropdown wms wms-caret-down"></i>`

        if (type === 'nochildren') {
            $targetNode.prepend(dropdownIcon)
            $previewNode.removeClass('tree-node-preview-prev')
        }

        if (side === 'bottom' || side === 'right') {
            const $insertAfter = $parent.children().length ? $parent.children().last() : $targetNode;  // Insert after last child or target node
            $previewNode.insertAfter($insertAfter);
        } else if (side === 'top' || side === 'left') {
            $previewNode.insertBefore($targetNode);
        } else {
            $previewNode.appendTo($parent);  // Default → append inside parent
        }

    }

    scrollElementIntoView(element: HTMLElement, container: HTMLElement) {
        const elementRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // Relative positions inside container
        const elementTop = elementRect.top - containerRect.top + container.scrollTop;
        const elementBottom = elementTop + element.offsetHeight;
        const visibleTop = container.scrollTop;
        const visibleBottom = visibleTop + container.clientHeight;

        // Horizontal calculations
        const elementLeft = elementRect.left - containerRect.left + container.scrollLeft;
        const elementRight = elementLeft + element.offsetWidth;
        const visibleLeft = container.scrollLeft;
        const visibleRight = visibleLeft + container.clientWidth;

        // Vertical scroll: center if element is not fully visible
        let scrollTop = container.scrollTop;
        let scrollLeft = container.scrollLeft;

        // Horizontal scroll: ensure indented content is visible
        const paddingLeft = parseInt(getComputedStyle(element).paddingLeft || '0', 10);

        // If indentation is outside the visible container, scroll
        if (paddingLeft < visibleLeft || paddingLeft + 70 > visibleRight) {
            scrollLeft = paddingLeft - 20;
        }

        // If element is not fully visible vertically
        if (elementTop < visibleTop || elementBottom > visibleBottom) {
            scrollTop = elementTop - (container.clientHeight / 2) + (element.offsetHeight / 2);
        }

        if (elementTop < visibleTop || elementBottom > visibleBottom || elementLeft < visibleLeft || elementRight > visibleRight) {
            container.scrollTo({
                top: Math.max(0, Math.min(scrollTop, container.scrollHeight - container.clientHeight)),
                left: Math.max(0, Math.min(scrollLeft, container.scrollWidth - container.clientWidth)),
                behavior: 'auto'
            });
        }
    }

    hideTreeNodePreview() {
        $('.tree-node-preview').remove();
        $('.preview-dropdown').remove()
        $('.tree-node').removeClass('drag-over-parent')
        $('.active-tree-element').css({ 'background': '#444444', 'color': '#ffffff' })
    }

    showTreeNode(type: string) {
        const pageStructureContainer = $('[name="wm-widget-group-widgets-tree"]');
        pageStructureContainer.removeClass('hidden').addClass('page-structure-overlay');

        if (this.alreadySelectedCategory !== 'wm-category-page-structure') {
            $(`[name="${this.alreadySelectedCategory}"]`).removeClass('active');
            $('[name="wm-category-page-structure"]').addClass('active');
        }
        // DISABLE HOVER EFFECTS DURING DRAG
        if (type === 'addWidget') {
            $('.tree-node').removeClass('active-tree-element').css({ 'background': 'transparent', 'color': '#bfbfbf' }).find('*').css('color', '#bfbfbf')
        }
    }

    hideTreeNode() {
        if (this.alreadySelectedCategory !== 'wm-category-page-structure') {
            const pageStructureContainer = $('[name="wm-widget-group-widgets-tree"]');
            pageStructureContainer.removeClass('page-structure-overlay').addClass('hidden');
            $('[name="wm-category-page-structure"]').removeClass('active');
            $(`[name="${this.alreadySelectedCategory}"]`).addClass('active');
        }
        // Remove Preview node
        this.hideTreeNodePreview()
    }
}
